goog.provide("shadow.js.shim.module$src$svg$person$person_2_outlined_svg");
goog.provide("module$shadow_js_shim_module$src$svg$person$person_2_outlined_svg");
shadow.js.shim.module$src$svg$person$person_2_outlined_svg = shadow.js.nativeProvides["src/svg/person/person-2-outlined.svg"] = shadow$bridge("src/svg/person/person-2-outlined.svg");
module$shadow_js_shim_module$src$svg$person$person_2_outlined_svg.default = shadow.js.shim.module$src$svg$person$person_2_outlined_svg;
